import React from 'react'
import ReactDOM from 'react-dom/client'
import {NextUIProvider} from '@nextui-org/react'
import {
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query'
import App from './pages/member-resources.jsx'
import './index.css'
import { initSentry } from './lib/sentry'

// Inicializar Sentry
initSentry();

const queryClient = new QueryClient()

ReactDOM.createRoot(document.getElementById('member-resources-root')).render(
  <React.StrictMode>
    <NextUIProvider>
      <QueryClientProvider client={queryClient}>
        <div className='twp'><App /></div>
      </QueryClientProvider>
    </NextUIProvider>
  </React.StrictMode>,
)
